module.exports = __webpack_public_path__ + "static/img/Dane-Rampe.59b7e60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dane-Rampe.jpg
// module id = SkoB
// module chunks = 0